
export default {
  name: 'OnlineStatusIndicator',
  props: {
    size: {
      type: String,
      default: '11px',
      required: false,
    },
  },
};
